import { call, put } from 'redux-saga/effects';
import serviceLocator, { SSAP_SVC } from '../../APIs/common/service-locator';
import { setFlow } from '../../actions/ssap/ssapActionCreators';
import { flowTypes as FLOW_TYPES } from '../../constants/ssap/flows/flowTypes';

export function* flowSaga() {
    const ssapService = yield call(serviceLocator, SSAP_SVC);
    const flow = yield call([ssapService, ssapService.getFlow]);
    if(flow) {
        const { financialFlow } = flow;
        yield put(
            setFlow(
                financialFlow
                    ? FLOW_TYPES.NON_FINANCIAL_FLOW_SWITCHABLE
                    : FLOW_TYPES.NON_FINANCIAL_FLOW_NON_SWITCHABLE
            )
        );
    }
}